<script>
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";

  export let db = null;
  export let activeDiary = null;
  export let activeMonth = null;
  export let activeYear = null;

  const dispatch = createEventDispatcher();

  let buttonBackTop = null;
  const feelings = {
    "": "",
    good: "🙂",
    stomachache: "🤕",
    nausea: "🤢",
    vomiting: "🤮",
  };

  onMount(() => {
    buttonBackTop = document.getElementById("buttonBackTop");
    const title = document.getElementById("title");
    title.innerHTML = moment(activeDiary.date).format("YYYY-MM-DD");

    setHTMLData("red");
    setHTMLData("lunch");
    setHTMLData("diner");
    setHTMLData("other");

    if (!activeDiary._id) {
      const buttonDelete = document.getElementById("buttonDelete");
      const rootStyle = getComputedStyle(document.body);
      const disabledColor = rootStyle.getPropertyValue("--gray-color");
      buttonDelete.style.backgroundColor = disabledColor;
      buttonDelete.classList.add("disabled");
    }

    window.onscroll = function () {
      onScroll();
    };
  });

  function goBack(diaryRemoved = false, diaryCreated = null) {
    const activeDate = moment(
      activeYear + "-" + (activeMonth + 1),
      "YYYY-MM-DD"
    );

    if (diaryRemoved) {
      dispatch("switchModule", {
        newModule: "calendar",
        activeDate: activeDate.format("YYYY-MM-DD"),
        diaryRemoved: moment(activeDiary.date).format("YYYY_MM_DD"),
      });
    } else if (diaryCreated) {
      dispatch("switchModule", {
        newModule: "calendar",
        activeDate: activeDate.format("YYYY-MM-DD"),
        diaryCreated: moment(activeDiary.date).format("YYYY_MM_DD"),
      });
    } else {
      dispatch("switchModule", {
        newModule: "calendar",
        activeDate: activeDate.format("YYYY-MM-DD"),
      });
    }
  }

  function saveDiary() {
    const redSelect = document.getElementById("redSelect");
    const redMenu = document.getElementById("redMenu");
    const redIngredients = document.getElementById("redIngredients");

    const lunchSelect = document.getElementById("lunchSelect");
    const lunchMenu = document.getElementById("lunchMenu");
    const lunchIngredients = document.getElementById("lunchIngredients");

    const dinerSelect = document.getElementById("dinerSelect");
    const dinerMenu = document.getElementById("dinerMenu");
    const dinerIngredients = document.getElementById("dinerIngredients");

    const otherSelect = document.getElementById("otherSelect");
    const otherMenu = document.getElementById("otherMenu");
    const otherIngredients = document.getElementById("otherIngredients");

    let rev = 0;
    if (activeDiary._rev) {
      rev = activeDiary._rev.split("-")[0] >= 1;
    }

    if (
      !redSelect.value &&
      !redMenu.value &&
      !redIngredients.value &&
      !lunchSelect.value &&
      !lunchMenu.value &&
      !lunchIngredients.value &&
      !dinerSelect.value &&
      !dinerMenu.value &&
      !dinerIngredients.value &&
      !otherSelect.value &&
      !otherMenu.value &&
      !otherIngredients.value
    ) {
      if (rev === 0) {
        goBack(false);
        return;
      } else {
        deleteDiary();
      }
    }

    let newDiary = {};
    if (activeDiary._id) {
      newDiary = activeDiary;
    } else {
      newDiary._id = "diary_" + moment(activeDiary.date).format("YYYY_MM_DD");
    }
    newDiary.red = {
      feeling: redSelect.value,
      menu: convertTextareatoArray(redMenu.value),
      ingredients: convertTextareatoArray(redIngredients.value),
    };
    newDiary.lunch = {
      feeling: lunchSelect.value,
      menu: convertTextareatoArray(lunchMenu.value),
      ingredients: convertTextareatoArray(lunchIngredients.value),
    };
    newDiary.diner = {
      feeling: dinerSelect.value,
      menu: convertTextareatoArray(dinerMenu.value),
      ingredients: convertTextareatoArray(dinerIngredients.value),
    };
    newDiary.other = {
      feeling: otherSelect.value,
      menu: convertTextareatoArray(otherMenu.value),
      ingredients: convertTextareatoArray(otherIngredients.value),
    };

    db.put(newDiary, (err, response) => {
      if (err) {
        console.log(err);
      } else {
        activeDiary._rev = response.rev;
      }
    });

    goBack(false, newDiary);
  }

  async function deleteDiary() {
    const buttonDelete = document.getElementById("buttonDelete");
    if (buttonDelete.classList.contains("disabled")) return;

    await db.remove(activeDiary);
    goBack(true);
  }

  function setHTMLData(key) {
    const diary = activeDiary[key] || {
      feeling: "",
      menu: "",
      ingredients: "",
    };

    const keyEmoji = document.getElementById(key + "Emoji");
    const keySelect = document.getElementById(key + "Select");
    const keyMenu = document.getElementById(key + "Menu");
    const keyIngredients = document.getElementById(key + "Ingredients");

    keyEmoji.innerHTML = feelings[diary.feeling] || "";
    keySelect.value = diary.feeling || "";
    keyMenu.value = diary.menu ? diary.menu.join("\n") : "";
    keyIngredients.value = diary.ingredients
      ? diary.ingredients.join("\n")
      : "";

    onTextareaInputGrow(keyMenu);
    onTextareaInputGrow(keyIngredients);
  }

  function convertTextareatoArray(text) {
    var lines = text.split(/\r?\n/);
    var output = [];
    lines.forEach((line) => {
      if (/\S/.test(line)) {
        output.push(line.trim());
      }
    });
    return output;
  }

  function onFeelingSelectChanged(event) {
    const element = event.target;
    const name = element.name.split("Select")[0];
    const feeling = element.value;

    const emojiElement = document.getElementById(name + "Emoji");
    emojiElement.innerHTML = feelings[feeling];
  }

  function onTextareaInputGrow(element) {
    element.style.height = "21px";
    element.style.height = element.scrollHeight + 1 + "px";
  }

  function onScroll() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      buttonBackTop.style.display = "block";
    } else {
      buttonBackTop.style.display = "none";
    }
  }

  function scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
</script>

<style>
  #header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    padding: 24px 0 0 0;
  }

  #back,
  #save {
    width: 35px;
    height: 35px;

    margin: 0;

    font-size: 25px;
    color: var(--main-text-color);

    border-radius: 50%;
    border: 0;
    outline: 0;
    background-color: var(--background-color);
    cursor: pointer;
  }

  #back:hover,
  #save:hover {
    border: 1px solid var(--orange-color);
    color: var(--orange-color);
  }

  #save {
    font-size: 24px;
  }

  h1 {
    display: inline-block;
    margin: 0;
    padding: 0;
    font-size: 45px;
    font-weight: 600;
    line-height: 55px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 5px;
    vertical-align: middle;
    color: var(--foreground-color);
  }

  .hr {
    width: 70%;
    height: 1.2px;
    margin: 21.8px auto 20px auto;
    background-color: var(--border-color);
  }

  .foodBlock {
    position: relative;
    display: block;
    width: 90%;
    height: auto;
    margin: 20px auto;
    border: 1px solid var(--border-color);
  }

  .foodBlockTitle {
    display: table;
    width: auto;
    margin: 4px auto 15px auto;
    font-size: 20px;
    font-weight: normal;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    border-bottom: 1px solid var(--border-color);
    color: var(--foreground-color);
  }

  .foodBlockEmoji {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 30px;
    height: 30px;
    margin: 0;
    padding: 0 1.5px;
    font-size: 20px;
    line-height: 30px;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    color: var(--foreground-color);
    box-shadow: 1px 1px 5px var(--shadow-color1);
  }

  .foodBlockSelect,
  .foodBlockSelect option {
    display: block;
    width: 90%;
    margin: 4px auto 15px auto;
    padding: 2.5px;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: var(--foreground-color);
    border: 1px solid var(--border-color);
    background-color: var(--background-color);
  }

  .foodBlockLabel {
    display: block;
    width: 90%;
    margin: 4px auto 15px auto;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: var(--foreground-color);
  }

  .foodBlockInput {
    display: block;
    width: 90%;
    height: 22px;
    margin: 0 auto 20px auto;
    font-size: 18px;
    text-align: left;
    border: 0;
    border-bottom: 1px dashed var(--border-color);
    outline: 0;
    resize: none;
    overflow: hidden;
    color: var(--foreground-color);
  }

  #buttonBackTop,
  #buttonDelete {
    display: none;
    position: fixed;
    bottom: 5px;
    right: 5px;
    width: 40px;
    height: 40px;
    font-size: 20px;
    line-height: 40px;
    border: none;
    border-radius: 50px;
    outline: none;
    color: var(--background-color);
    background-color: var(--orange-color);
    box-shadow: 1px 1px 5px var(--shadow-color1);
    cursor: pointer;
    z-index: 99;
  }
  #buttonDelete {
    display: block;
    right: 0;
    left: 5px;
  }

  .foodBlock:nth-child(3),
  .foodBlock:nth-child(3) .foodBlockTitle,
  .foodBlock:nth-child(3) .foodBlockEmoji,
  .foodBlock:nth-child(3) .foodBlockSelect {
    color: var(--red-color);
    border-color: var(--red-color);
  }

  .foodBlock:nth-child(4),
  .foodBlock:nth-child(4) .foodBlockTitle,
  .foodBlock:nth-child(4) .foodBlockEmoji,
  .foodBlock:nth-child(4) .foodBlockSelect {
    color: var(--blue-color);
    border-color: var(--blue-color);
  }

  .foodBlock:nth-child(5),
  .foodBlock:nth-child(5) .foodBlockTitle,
  .foodBlock:nth-child(5) .foodBlockEmoji,
  .foodBlock:nth-child(5) .foodBlockSelect {
    color: var(--yellow-color);
    border-color: var(--yellow-color);
  }

  .foodBlock:nth-child(6) {
    margin: 20px auto 25px auto;
  }

  .foodBlock:nth-child(6),
  .foodBlock:nth-child(6) .foodBlockTitle,
  .foodBlock:nth-child(6) .foodBlockEmoji,
  .foodBlock:nth-child(6) .foodBlockSelect {
    color: var(--green-color);
    border-color: var(--green-color);
  }

  .foodBlock:nth-child(3) .foodBlockEmoji {
    background-color: var(--red-color);
  }

  .foodBlock:nth-child(4) .foodBlockEmoji {
    background-color: var(--blue-color);
  }

  .foodBlock:nth-child(5) .foodBlockEmoji {
    background-color: var(--yellow-color);
  }

  .foodBlock:nth-child(6) .foodBlockEmoji {
    background-color: var(--green-color);
  }

  .foodBlock:nth-child(3) .foodBlockSelect,
  .foodBlock:nth-child(4) .foodBlockSelect,
  .foodBlock:nth-child(5) .foodBlockSelect,
  .foodBlock:nth-child(6) .foodBlockSelect {
    color: var(--foreground-color);
  }

  #footer {
    display: block;
    width: 100%;
    padding: 1% 0 0.5% 0;
    width: 100%;
    height: auto;
  }

  #footer p,
  #footer :global(a) {
    width: auto;
    color: var(--main-text-color);
    text-align: center;
    font-size: 4vw;
  }
  #footer :global(a) {
    text-decoration: underline;
  }

  @media (min-width: 1024px) {
    #header,
    .foodBlock {
      width: 60%;
      margin: 0 auto;
    }
    .foodBlockEmoji {
      padding: 0 2.5px;
    }

    #footer p,
    #footer :global(a) {
      font-size: 1.1vw;
    }
  }
</style>

<div id="header">
  <button
    id="back"
    class="fas fa-long-arrow-alt-left"
    on:click={() => goBack()} />
  <h1 id="title">Date</h1>
  <button id="save" class="fas fa-save" on:click={() => saveDiary()} />
</div>

<div class="hr" />

<div class="foodBlock">
  <h2 class="foodBlockTitle">{$_('diary.title.red')}</h2>

  <div id="redEmoji" class="foodBlockEmoji" />

  <select
    id="redSelect"
    class="foodBlockSelect"
    name="redSelect"
    on:change={(e) => onFeelingSelectChanged(e)}>
    <option label={$_('diary.select.default')} value="" />
    <option label={$_('diary.select.good')} value="good" />
    <option label={$_('diary.select.stomachache')} value="stomachache" />
    <option label={$_('diary.select.nausea')} value="nausea" />
    <option label={$_('diary.select.vomiting')} value="vomiting" />
  </select>

  <label for="redMenu" class="foodBlockLabel">{$_('diary.menu')}</label>
  <textarea
    type="text"
    id="redMenu"
    class="foodBlockInput"
    name="redMenu"
    on:input={(e) => onTextareaInputGrow(e.target)} />

  <label
    for="redIngredients"
    class="foodBlockLabel">{$_('diary.ingredients')}</label>
  <textarea
    type="text"
    id="redIngredients"
    class="foodBlockInput"
    name="redIngredients"
    on:input={(e) => onTextareaInputGrow(e.target)} />
</div>

<div class="foodBlock">
  <h2 class="foodBlockTitle">{$_('diary.title.lunch')}</h2>

  <div id="lunchEmoji" class="foodBlockEmoji" />

  <select
    id="lunchSelect"
    class="foodBlockSelect"
    name="lunchSelect"
    on:change={(e) => onFeelingSelectChanged(e)}>
    <option label={$_('diary.select.default')} value="" />
    <option label={$_('diary.select.good')} value="good" />
    <option label={$_('diary.select.stomachache')} value="stomachache" />
    <option label={$_('diary.select.nausea')} value="nausea" />
    <option label={$_('diary.select.vomiting')} value="vomiting" />
  </select>

  <label for="lunchMenu" class="foodBlockLabel">{$_('diary.menu')}</label>
  <textarea
    type="text"
    id="lunchMenu"
    class="foodBlockInput"
    name="lunchMenu"
    on:input={(e) => onTextareaInputGrow(e.target)} />

  <label
    for="lunchIngredients"
    class="foodBlockLabel">{$_('diary.ingredients')}</label>
  <textarea
    type="text"
    id="lunchIngredients"
    class="foodBlockInput"
    name="lunchIngredients"
    on:input={(e) => onTextareaInputGrow(e.target)} />
</div>

<div class="foodBlock">
  <h2 class="foodBlockTitle">{$_('diary.title.diner')}</h2>

  <div id="dinerEmoji" class="foodBlockEmoji" />

  <select
    id="dinerSelect"
    class="foodBlockSelect"
    name="dinerSelect"
    on:change={(e) => onFeelingSelectChanged(e)}>
    <option label={$_('diary.select.default')} value="" />
    <option label={$_('diary.select.good')} value="good" />
    <option label={$_('diary.select.stomachache')} value="stomachache" />
    <option label={$_('diary.select.nausea')} value="nausea" />
    <option label={$_('diary.select.vomiting')} value="vomiting" />
  </select>

  <label for="dinerMenu" class="foodBlockLabel">{$_('diary.menu')}</label>
  <textarea
    type="text"
    id="dinerMenu"
    class="foodBlockInput"
    name="dinerMenu"
    on:input={(e) => onTextareaInputGrow(e.target)} />

  <label
    for="dinerIngredients"
    class="foodBlockLabel">{$_('diary.ingredients')}</label>
  <textarea
    type="text"
    id="dinerIngredients"
    class="foodBlockInput"
    name="dinerIngredients"
    on:input={(e) => onTextareaInputGrow(e.target)} />
</div>

<div class="foodBlock">
  <h2 class="foodBlockTitle">{$_('diary.title.other')}</h2>

  <div id="otherEmoji" class="foodBlockEmoji" />

  <select
    id="otherSelect"
    class="foodBlockSelect"
    name="otherSelect"
    on:change={(e) => onFeelingSelectChanged(e)}>
    <option label={$_('diary.select.default')} value="" />
    <option label={$_('diary.select.good')} value="good" />
    <option label={$_('diary.select.stomachache')} value="stomachache" />
    <option label={$_('diary.select.nausea')} value="nausea" />
    <option label={$_('diary.select.vomiting')} value="vomiting" />
  </select>

  <label for="otherMenu" class="foodBlockLabel">{$_('diary.menu')}</label>
  <textarea
    type="text"
    id="otherMenu"
    class="foodBlockInput"
    name="otherMenu"
    on:input={(e) => onTextareaInputGrow(e.target)} />

  <label
    for="otherIngredients"
    class="foodBlockLabel">{$_('diary.ingredients')}</label>
  <textarea
    type="text"
    id="otherIngredients"
    class="foodBlockInput"
    name="otherIngredients"
    on:input={(e) => onTextareaInputGrow(e.target)} />
</div>

<button id="buttonDelete" class="fas fa-trash" on:click={() => deleteDiary()} />
<button
  id="buttonBackTop"
  class="fas fa-angle-up"
  on:click={() => scrollTop()} />

<footer id="footer">
  <p>
    {@html $_('app.copyright')}
  </p>
</footer>
